<template>
  <div class="container responsibilities_block">
    <component
      :is="getIsMobile ? 'swiper' : 'div'"
      v-bind="component_params">
      <swiper-slide
        v-for="(responsibility, index) in responsibilities"
        :class="getIsMobile ? 'col-12' : 'col-sm-4'"
        :key="`swiper-slide_${index}_${uid}`">
        <div class="responsibilities_block-item h-100">
          <default-title
            title_tag="div"
            white
            smaller
            class="responsibilities_block-item_title"
            :title="responsibility.title"
          />
          <html-block
            class="responsibilities_block-item_content"
            :content="responsibility.content"
          />
        </div>
      </swiper-slide>
    </component>
  </div>
</template>

<script>
import DefaultButton from "../slots/DefaultButton.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import PreviewArticle from "../parts/builder/PreviewArticle.vue";
import uid_mixin from "../../mixins/uid_mixin";
import {mapGetters} from "vuex";

export default {
  name: "ResponsibilitiesBlock",
  mixins: [uid_mixin],
  components: {
    PreviewArticle,
    SwiperSlide,
    Swiper,
    HtmlBlock,
    DefaultTitle,
    DefaultButton,
  },
  props: {
    /**props**/
    responsibilities: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
      }
    }
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    component_params() {
      if (!this.getIsMobile) {
        return {
          'class': 'row'
        }
      }
      return {
        class: 'position-relative',
        add_navigation_buttons: true,
        fade_effect: true,
        next_btn_class: 'responsibilities_block_next_btn',
        prev_btn_class: 'responsibilities_block_prev_btn',
        swiper_config: {
          spaceBetween: 20
        },
      }
    },
    swiper_breakpoints() {
      return {
        576: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20
        },
      }
    },
  }
}
</script>
